import { useState } from 'react';
import { upperFirst } from 'lodash';

import { ApiErrorMessage } from 'constants/ErrorMessages';
import BaseAlert from 'components/wrappers/BaseAlert';
import { isAdminSelector } from 'redux/selectors/authenticationSelectors';
import { checkIsContactUsedInActiveAssignment } from 'redux/reducers/accountSlice';
import { useAppSelector } from 'hooks/useAppSelector';
import { useAppDispatch } from 'hooks/useAppDispatch';

export default function useCanRemoveContact(entityName: string) {
  const isAdmin = useAppSelector(isAdminSelector);
  const dispatch = useAppDispatch();
  const [canRemoveOptions, setCanRemoveOptions] = useState({
    isLoading: false,
    contactId: '',
  });

  const checkCanRemoveContact = async (contactId?: string) => {
    if (!contactId) {
      return true;
    }

    setCanRemoveOptions({
      isLoading: true,
      contactId,
    });

    const result = await dispatch(
      checkIsContactUsedInActiveAssignment({
        isAdmin,
        contactId,
      }),
    );

    setCanRemoveOptions({
      isLoading: false,
      contactId,
    });

    if (checkIsContactUsedInActiveAssignment.fulfilled.match(result)) {
      if (!!result.payload) {
        BaseAlert.error(
          `${upperFirst(
            entityName,
          )} is used in the active assignment. You can update the contact but you cannot delete it.`,
        );

        return false;
      }

      return true;
    } else {
      BaseAlert.error(result.error.message || ApiErrorMessage);

      return false;
    }
  };

  return [canRemoveOptions, checkCanRemoveContact] as const;
}
